/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React, { CSSProperties, DetailedHTMLProps, HTMLAttributes } from "react";
import ReactTooltip from "react-tooltip";
import { ICategoryType, ILearnisticTag } from "../generated/Api";
import { customTooltip } from "../styles/general";
import { ITag } from "../types/TagTypes";
import IconBerserkerMail from "./Icon";

const Container = styled(motion.div)<{ type: string }>`
  background: ${(props) => (props.type === "user" ? "#fb972e19" : "#f8f8f8")} 0%
    0% no-repeat padding-box;
  border: 1px solid
    ${(props) => (props.type === "user" ? "#fb972e" : "#e0e0e0")};
  border-radius: 15px;
  opacity: 1;
  color: #fb972e;
  padding: 7px 12px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: default;
  width: fit-content;
  max-height: 32px;
  max-width: 90%;
`;

const Icon = styled.div`
  margin-left: 10px;
  margin-top: 2px;
  cursor: pointer;
`;

const TextContainer = styled.div`
  text-overflow: ellipsis;
  max-width: 312px;
  overflow: hidden;
  white-space: nowrap;
`;

const TooltipText = styled.span`
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff;
  text-align: center;
`;

interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  tag: ILearnisticTag;
  customStyle?: CSSProperties;
  isLayout?: boolean;
  tooltip?: string;
  disabled?: boolean;
  deleteTag?: (vl: ILearnisticTag) => void;
  noPopUp?: boolean;
}

export default function LearnisticTag(props: Props): JSX.Element | null {
  const { tag, deleteTag, customStyle, isLayout, tooltip, disabled, noPopUp } =
    props;

  if (!tag) return null;
  return (
    <Container
      style={customStyle}
      layout={isLayout}
      type="user"
      data-tip
      data-for={tag.id}
    >
      <TextContainer>{tag.name}</TextContainer>
      {!noPopUp && (
        <ReactTooltip
          id={tag.id.toString()}
          place="top"
          effect="solid"
          backgroundColor="#333333"
          css={customTooltip}
        >
          <TooltipText>{tooltip ?? `LEARNISTIC -> ${tag.name}`}</TooltipText>
        </ReactTooltip>
      )}
      {deleteTag && !disabled && (
        <Icon onClick={() => deleteTag(tag)}>
          <IconBerserkerMail name="close-orange" width={9} height={9} />
        </Icon>
      )}
    </Container>
  );
}
